
import actions from './actions'
export default {
  criarNovoSiteSemSiteCadastrado: {
    página: 'Plano sem sites',
    category: '[Lista de sites] Plano sem sites',
    action: actions.clickButton,
    label: 'Criar novo site (sem site cadastrado)'
  }
}
